module.exports = __webpack_public_path__ + "img/051.b8927f94.jpeg";